import { render, staticRenderFns } from "./HistoricoGeral.vue?vue&type=template&id=76b19de0&"
import script from "./HistoricoGeral.vue?vue&type=script&lang=js&"
export * from "./HistoricoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports